import React from "react";
import { PROMOTION_DATA } from "../../../config/DATA";
import { useTranslation } from "react-i18next";

const PromotionsPage = () => {
  const { t } = useTranslation();
  const promotionData= PROMOTION_DATA();
  return (
    <>
      <style jsx="true">
        {`
          h1 {
            margin: 24px 0px;
            position: relative;
            overflow: hidden;
            text-transform: none;
            color: rgb(255, 255, 255);
            font-weight: 600;
            font-size: 32px;
            line-height: 41.6px;
            padding-left: 74px;
          }
          h1:before {
            content: "";
            position: absolute;
            inset: 0px 0px 0px 22px;
            background: rgb(218, 14, 14);
            opacity: 0.3;
            z-index: 1;
            width: 40px;
            transform: skew(-10deg, 0deg);
            max-height: 41px;
          }
          h1:after {
            content: "";
            position: absolute;
            inset: 0px 0px 0px 8px;
            background: rgb(218, 14, 14);
            z-index: 1;
            width: 10px;
            transform: skew(-10deg, 0deg);
            max-height: 41px;
          }
        `}
      </style>
      <div className="max-w-[920px] mx-auto my-5 rounded-xl p-5 bg-[#313346]">
        <h1>{t("Promotions")}</h1>
        <div className="grid grid-cols-2 gap-4">
          {promotionData.map((item, index) => {
            return (
              <div key={index} className="bg-[#191820] p-4 rounded-lg relative">
                <img src={item.image} alt={item.title} />
                <h5 className="text-primary my-8 text-center">{item.title}</h5>
                <p className="my-5 text-center">{item.shortDesc}</p>
                <div className="flex justify-end">
                  <button className="border border-primary min-w-40 rounded-xl text-primary py-2 px-3 ">{t("Read More")}</button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default PromotionsPage;
